import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

export interface ReplyActionProps {
  onClick: () => void;
}

export const ReplyAction = ({ onClick }: ReplyActionProps) => {
  const { t } = useTranslation('team-chat');
  return (
    <Button
      variant='secondary'
      onClick={onClick}
      css={styles}
      trackingId='team-chat-2.0-open-threads'
      hoverLabel={t('Reply in Thread')}
    >
      <Icon name='chat' />
    </Button>
  );
};

const styles = css`
  min-width: ${theme.spacing(4)};
  width: ${theme.spacing(4)};
  border: unset;
  padding: 0;
`;
